// extracted by mini-css-extract-plugin
export default {"wrapper":"SectionItem_wrapper__4Vcr7"};